<template>
  <div class="footer-wrapper">
    <div class="container-fluid footer-pic">
      <img src="../assets/image/home/footer-bg.png" alt="" />
      <!-- <img :src="footerBg" alt="" /> -->
    </div>
    <!-- 联系我们 -->
    <section class="footer-contact container-fluid" id="contact">
      <div class="contact-us">
        <h3>CONTACT US</h3>
        <h3 class="title">联系我们</h3>
        <div class="contact-info">
          <ul>
            <li>
              <div class="label">姓名</div>
              <input type="text" v-model="user.name" />
            </li>
            <li>
              <div class="label">电话</div>
              <input type="text" v-model="user.mobile" />
            </li>
            <li>
              <div class="label">邮箱</div>
              <input type="text" v-model="user.email" />
            </li>
          </ul>
          <div class="sumbit-btn" @click="submit()">确定</div>
        </div>
      </div>
    </section>

    <!-- link -->
    <!-- container-fluid -->
    <div class="footer footer-info">
      <div class="container join-info">
        <div class="top">
          <div class="footer-link">
            <div class="large-link">
              <router-link to="/brand">关于希诺</router-link>
              <router-link to="/joinUs">招商加盟</router-link>
              <a href="#contact">联系我们</a>
            </div>
            <div class="small-link">
              <router-link to="/news">媒体中心</router-link>
              <router-link to="/joinUs">品牌加盟</router-link>
              <router-link to="/hotelScene">环境展示</router-link>
            </div>
          </div>
          <div class="qrcode">
            <!-- <img :src="qrcode" alt="" /> -->
            <img src="../assets/image/home/qrc@2x.png" alt="" />
          </div>
        </div>
        <div class="bottom">
          <div class="customer-service">
            客户服务热线：400 - 688 - 1114 周一至周日 9:00 - 18:00
          </div>
          <div class="copyright">
            广州市壹隅酒店管理有限公司
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              >Copyright ©1998-2018 neohotels.cn 粤ICP备19016096号-1</a
            >
            <a href="#" target="_blank">法律声明</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imgBaseUrl } from "../utils/http";
export default {
  name: "MyFooter",
  data() {
    return {
      user: {
        name: "",
        mobile: "",
        email: "",
      },
      showPC: true,
      footerBg: `${imgBaseUrl}/image/home/footer-bg.png`, //背景图1
      qrcode: `${imgBaseUrl}/image/home/qrc@2x.png`, //二维码
    };
  },
  created() {
    this.mywidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (this.mywidth > 768) {
      this.showPC = true;
    }
  },
  methods: {
    contanthandel() {
      const regMobile = /^1[3-9]\d{9}$/;
      const testMobile = regMobile.test(this.user.mobile);
      // if (!testMobile) {
      //   this.$message({
      //     message: `请输入格式正确的手机号`,
      //     offset: 100,
      //     type: "error",
      //   });
      //   return;
      // }

      this.$http.post("/api/contact", this.user).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: `联系方式填写成功！`,
            offset: 100,
            type: "success",
          });
          this.user = {
            name: "",
            mobile: "",
            email: "",
          };
        } else {
          this.$message({
            message: `${res.data.msg}`,
            offset: 100,
            type: "error",
          });
        }
      });
    },
    submit() {
      this.showPC && this.contanthandel();
    },
  },
};
</script>

<style lang="less">
@media (max-width: 1200px) {
  .footer-wrapper input {
    height: 38px !important;
  }
  .bottom {
    font-size: 12px !important;
    a {
      font-size: 12px !important;
    }
  }
}
@media (max-width: 1400px) {
  .bottom {
    font-size: 12px !important;
    a {
      font-size: 12px !important;
    }
  }
}
.container {
  padding: 0;
}

.wrapper {
  // width: 1440px;
  // margin: 0 auto;
}
.row > * {
  padding: 0;
}
.footer {
  // width: 1920px;
  // height: 818px;
  img {
    width: 100%;
  }
}
// .footer-bg {
//   width: 1920px;
//   height: 1080px;
//   margin: 0 auto;

// }
.footer-pic {
  padding: 0;
}
.footer-contact {
  margin: 0 auto;
  // width: 1920px;
  // height: 830px;
  background-image: url(../assets/image/home/contact-bg.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .contact-us {
    // width: 579px;
    // height: 658px;
    width: 34.4%;

    // margin-right: 313px;
    // margin-right: 16.3%;
    margin: 4.7% 16.3% 4.7% 0;
    background-color: #fff;
    // padding: 40px 40px 66px;
    padding: 2.1% 2.1% 3.46%;

    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-weight: 600;
      line-height: 1.5;
      font-size: 1.5vw;
    }
    .contact-info {
      width: 86%;
      // margin-top: 20px;
      margin-top: 3.5%;
      li {
        margin-bottom: 5%;

        .label {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1a1a1a;
          line-height: 1.5;
          margin-bottom: 1.5%;
        }

        input {
          width: 100%;
          // width: 500px;
          height: 66px;
          outline: none;
          padding-left: 20px;
          border: 1px solid #e0ca76;
        }
      }
      .sumbit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        // width: 501px;
        width: 100%;
        // height: 66px;
        padding: 3%;
        margin-top: 3%;
        background-color: #e0ca76;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #1a1a1a;
      }
    }
  }
}
.footer-info {
  background-color: #000;
  padding: 160px 0;
  margin: 0 auto;
  color: #999;
  font-size: 16px;
  text-align: center;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: end;
    // height: 376px;
    margin-bottom: 106px;
    .footer-link {
      display: flex;
      justify-content: space-between;
      align-items: end;
      color: #ffffff;
      font-family: PingFangSC-Semibold, PingFang SC;
      a {
        color: #ffffff;
        display: block;
      }
      .large-link {
        // font-size: 80px;
        font-size: 3vw;
        font-weight: 600;

        margin-right: 160px;
        a {
          font-size: 3vw;
        }
      }
      .small-link {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 28px;
        margin-bottom: 12px;
        a {
          margin-top: 33px;
        }
      }
    }
    .qrcode {
      width: 24%;
      // width: 344px;
      // height: 163px;
      img {
        width: 100%;
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    .copyright {
      a {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
        margin: 0 10px;
      }
    }
  }
}
a:hover {
  text-decoration: none !important;
}
@media (min-width: 1980px) {
  .join-info {
    width: 1440px !important;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>